import { SearchService } from "../../services/SearchService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useSearchApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const searchService = new SearchService(appConfig.apiBaseUrl);

    const searchAvailableRooms = async (propertyId, checkin, checkout, occupancy) => {
        return executeApiOperation(() => searchService.search(propertyId, checkin, checkout, occupancy));
    };

    return {
        searchAvailableRooms,
    };
};